import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../Items/Navbar';
import StudyHubBackNav from '../navigation/StudyHubBackNav';
import AuthContext from '../shared/AuthContext';
import PageMeta from '../seo/PageMeta';
import useGamificationSummary from '../../hooks/useGamificationSummary';
import LearningProgressPanel from '../gamification/LearningProgressPanel';
import './LearningProfilePage.css';

export default function LearningProfilePage() {
  const { user } = useContext(AuthContext);
  const userProfile = user || JSON.parse(localStorage.getItem('userProfile') || 'null');
  const { summary, loading, error } = useGamificationSummary();

  return (
    <div className="learning-profile-page">
      <PageMeta title="Learning profile" description="Your QnaRead level, score, streak, and achievements" />
      <Navbar userProfile={userProfile} loading={false} />
      <main className="learning-profile-shell">
        <StudyHubBackNav />
        <header className="learning-profile-head">
          <h1>{userProfile?.fullName || 'Your profile'}</h1>
          <p>Learning progress, achievements, and privacy controls.</p>
        </header>

        {loading && <p className="learning-profile-muted">Loading progress…</p>}
        {error && <p className="learning-profile-error" role="alert">{error}</p>}

        {summary && (
          <>
            <LearningProgressPanel summary={summary} />
            <section className="learning-profile-section">
              <h2>Achievements</h2>
              {summary.recentAchievements?.length ? (
                <ul className="learning-profile-achievements">
                  {summary.recentAchievements.map((a) => (
                    <li key={a.code}>
                      <strong>{a.title}</strong>
                      <span>{a.description}</span>
                      <span className="learning-profile-rarity">{a.rarity}</span>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="learning-profile-muted">Your first achievement is close — complete a practice or review session.</p>
              )}
            </section>
            <section className="learning-profile-section">
              <h2>Score breakdown</h2>
              <ul className="learning-profile-breakdown">
                {Object.entries(summary.scoreBreakdown || {}).map(([key, val]) => (
                  <li key={key}>
                    <span>{key}</span>
                    <span>{val}/100</span>
                  </li>
                ))}
              </ul>
            </section>
            <p className="learning-profile-foot">
              <Link to="/settings">Settings</Link> — leaderboard visibility and notifications.
            </p>
          </>
        )}
      </main>
    </div>
  );
}
